const domReady = function (callback) {
    document.readyState === 'interactive' || document.readyState === 'complete'
        ? callback()
        : document.addEventListener('DOMContentLoaded', callback);
};

domReady(() => {
    $_vikon(window)
        .on('resize', () => {
            doubleScroll($_vikon('.vikon-responsive-table'));
        });
    createDoubleScroll();
});

$_vikon('.vikon-tabs li').mouseup(() => {
    createDoubleScroll();
});

function createDoubleScroll() {
    setTimeout(() => {
        doubleScroll($_vikon('.vikon-responsive-table'));
    }, 100);
}

function doubleScroll(elements) {
    $_vikon('.scrollDiv').remove();
    $_vikon.each(elements, (key, element) => {
        const table = element.querySelector('table');

        if (table.rows.length > 30) {
            const scrollbar = document.createElement('div');
            scrollbar.className = 'scrollDiv';
            scrollbar.appendChild(document.createElement('div'));
            scrollbar.style.overflow = 'auto';
            scrollbar.style.overflowY = 'hidden';
            scrollbar.firstChild.style.width = `${table.offsetWidth}px`;
            scrollbar.firstChild.style.height = `0px`;
            scrollbar.firstChild.style.paddingTop = '1px';
            scrollbar.firstChild.appendChild(document.createTextNode('\xA0'));
            scrollbar.onscroll = function () {
                element.scrollLeft = scrollbar.scrollLeft;
            };
            element.onscroll = function () {
                scrollbar.scrollLeft = this.scrollLeft;
            };
            element.parentNode.insertBefore(scrollbar, element);
        }
    });
}
